const ITEMS = [
  "Taglio Sartoriale",
  "Rito Barba con Panno Caldo",
  "Rasoio a Mano Libera",
  "Sfumature di Precisione",
  "Un'Ora Solo Per Te",
  "Atri — Borgo Ducale",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/[0.08] bg-espresso/60 py-5 overflow-hidden select-none">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-xl sm:text-2xl text-sand/80 px-6">{item}</span>
            <span className="text-ember text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
